module.exports = __webpack_public_path__ + "assets/c8e06b1175398e4c499948ffa852dd65.svg";